import { NAME } from './constants';

export const FETCH_SYSTEM_TYPES = `${NAME}/FETCH_SYSTEM_TYPES`;
export const FETCH_SYSTEM_TYPES_FAILURE = `${NAME}/FETCH_SYSTEM_TYPES_FAILURE`;
export const FETCH_SYSTEM_TYPES_SUCCESS = `${NAME}/FETCH_SYSTEM_TYPES_SUCCESS`;

export const INITIALIZE_FORM = `${NAME}/INITIALIZE_FORM`;

export const RESET = `${NAME}/RESET`;
export const RESET_FORM = `${NAME}/RESET_FORM`;

export const SAVE = `${NAME}/SAVE`;
export const SAVE_SUCCESS = `${NAME}/SAVE_SUCCESS`;
export const SAVE_FAILURE = `${NAME}/SAVE_FAILURE`;

export const SET_IS_NEW_RECORD = `${NAME}/SET_IS_NEW_RECORD`;
export const SET_IS_OPEN_MODAL = `${NAME}/SET_IS_OPEN_MODAL`;
